"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MicrophoneReadiness = require("./MicrophoneReadiness");
Object.keys(_MicrophoneReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MicrophoneReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MicrophoneReadiness[key];
    }
  });
});